export const RESET_CHANGE_REQUESTS = "RESET_CHANGE_REQUESTS";
export const SET_PROCESSING = "SET_PROCESSING";
export const STOP_PROCESSING = "STOP_PROCESSING";
export const LOAD_CHANGE_REQUESTS = "LOAD_CHANGE_REQUESTS";
export const GET_CHANGE_REQUESTS = "GET_CHANGE_REQUESTS";
export const FILTER_CHANGE_REQUESTS = "FILTER_CHANGE_REQUESTS";
export const MARK_CHANGE_REQUEST_AS_DONE = "MARK_CHANGE_REQUEST_AS_DONE";
export const DELETE_CHANGE_REQUEST = "DELETE_CHANGE_REQUEST";
export const SET_DELETING = "SET_DELETING";
export const ACCEPT_CHANGE_REQUEST = "ACCEPT_CHANGE_REQUEST";
export const SET_ACCEPTING = "SET_ACCEPTING"

